import React from "react";
import { cn } from "@/utils/cn";

interface PostCardContainerProps {
  viewMode?: "grid" | "list" | "feed";
  className?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  children: React.ReactNode;
}

export const PostCardContainer: React.FC<PostCardContainerProps> = ({
  viewMode = "grid",
  className,
  onMouseEnter,
  onMouseLeave,
  children,
}) => {
  if (viewMode === "list") {
    return (
      <div
        className={cn(
          "bg-white rounded-xl p-4 hover:shadow-md transition-all duration-200",
          className
        )}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </div>
    );
  }

  if (viewMode === "feed") {
    return (
      <div
        className={cn(
          "bg-white border-y border-gray-200 group relative flex flex-col w-full overflow-visible",
          className
        )}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      className={cn(
        "bg-white rounded-xl hover:shadow-lg transition-all duration-300 group relative flex flex-col w-full",
        className
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
};
